<template>
  <div>
    <el-table
      :data="tableData"
      v-loading="loading"
      size="mini"
      ref="table"
      highlight-current-row
      @current-change="handleCurrentChange"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        :label="$l('project_table_label_pro_no')||'项目编号'"
        min-width="180"
        prop="prjNo"
      >
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="prjTitle"
        :label="$l('project_table_label_pro_title')||'项目名称'"
        min-width="180"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="prjCategoryName"
        :label="$l('project_table_label_pro_category')||'项目分类'"
        min-width="180"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="custName"
        :label="$l('project_table_label_customer')||'客户'"
        min-width="180"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="prjStatusName"
        :label="$l('project_table_label_status')||'状态'"
        min-width="60"
      ></el-table-column>
      <div slot="empty">
        <div class="mt-60">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{$l('INDEX.tips_no_data')||'暂无数据！'}}</p>
        </div>
      </div>
    </el-table>
  </div>
</template>

<script>
import util from '@/libs/util.cookies'
export default {
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  components: {
  },
  data () {
    return {
      // 选中的数据
      currentRow: null
    }
  },
  watch: {
  },
  methods: {
    handleCurrentChange (val) {
      this.currentRow = val
    },
    setCurrent (row) {
      this.$refs.table.setCurrentRow(row)
    },
    save () {
      if (!this.currentRow) {
        this.$message.warning('请选择一个项目!')
        return
      }
      util.set('proInfo', this.currentRow)
      this.$confirm(`是否确认把项目[<span style="color: #67C23A">${this.currentRow.prjTitle}</span>]加入客户推荐？`, '提示', {
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$emit('success')
      })
    }
  }
}
</script>
